import * as React from 'react';

import { Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { AlertProps } from '@mui/material/Alert';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import { useSnackbar } from '../../contexts/SnackBarContext';
import { User, getUser } from '../types/User';
import { Modal } from './Modal';
import { httpGet } from '../Web';
import { UserContext } from '../UserProvider';

export interface ProfileModalProps {
    open: boolean,
    handleClose: () => void
}

export const ProfileModal = () => {
    const user = React.useContext(UserContext);
    const { showSnackbar } = useSnackbar();
    const [userDB, setUserDB] = React.useState<User>();

    const logoutHandler = () => {
        httpGet('/api/account/logout', new AbortController());
    }

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        async function getDBUser() {
            if (user.user.id) {
                const dBUser = await getUser(user.user.id, new AbortController());

                if (dBUser.failed || dBUser.result === undefined) {
                    showUserFeedback(dBUser.errorText);
                    return;
                }
                setUserDB(dBUser.result);
            }
        }

        getDBUser();
    }, [user, showUserFeedback ]);

    return <Modal title='Profile' maxWidth='xs'>
        <List>
            <ListItem>
                <ListItemText>{userDB ? ('Logged in as: ' + userDB?.name + ' : ' +
                    (userDB?.accessLevel === 2 ? 'Admin' : userDB?.accessLevel === 1 ? 'Tester' : 'Guest')) :
                    ''
                }</ListItemText>
            </ListItem>
            {/*   <ListItem>
                <ListItemButton>
                    <ListItemIcon>
                        <SettingsIcon/>
                    </ListItemIcon>
                    <ListItemText>Edit companies profile</ListItemText>
                </ListItemButton>
            </ListItem>
            <ListItem>
                <ListItemButton>
                    <ListItemIcon>
                        <PersonIcon/>
                    </ListItemIcon>
                    <ListItemText>Edit users profile</ListItemText>
                </ListItemButton>
            </ListItem> */}
        </List>
        <Button disabled={user.loginStatus!==2} startIcon={<LockIcon/>} onClick={logoutHandler}>Logout</Button>
    </Modal>
}
